/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TenantMasterData } from '../../models/tenant-master-data';
import { TenantMasterDataUpdateRequest } from '../../models/tenant-master-data-update-request';

export interface UpdateTenantMasterData$Params {

/**
 * tenant shortcode
 */
  tenant_short_code: string;

/**
 * Id of a resource.
 */
  id: string;
      body: TenantMasterDataUpdateRequest
}

export function updateTenantMasterData(http: HttpClient, rootUrl: string, params: UpdateTenantMasterData$Params, context?: HttpContext): Observable<StrictHttpResponse<TenantMasterData>> {
  const rb = new RequestBuilder(rootUrl, updateTenantMasterData.PATH, 'put');
  if (params) {
    rb.path('tenant_short_code', params.tenant_short_code, {"style":"simple","explode":false});
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TenantMasterData>;
    })
  );
}

updateTenantMasterData.PATH = '/api/v1/tenants/{tenant_short_code}/masterdata/{id}';
